import type { AssigneeType } from '@heidi/schema/ml-scribe';
import { useEffect, useState } from 'react';

interface DisplayAssignee {
  name: string | null;
  avatarUrl: string | null;
  type?: AssigneeType;
}

interface UseDisplayAssigneeParams {
  open: boolean;
  assigneeId?: string | null;
  assigneeName?: string | null;
  assigneeAvatarUrl?: string | null;
  assigneeType?: AssigneeType;
}

/**
 * Snapshots the current-assignee row's content while the popover is open,
 * then holds it through the close animation. Without this, clearing the
 * assignee (which nulls assigneeId/assigneeName synchronously via the
 * onValueChange prop) unmounts the row mid-exit, causing the dropdown list
 * to visibly jump while the DropdownMenu is still fading out.
 */
export function useDisplayAssignee({
  open,
  assigneeId,
  assigneeName,
  assigneeAvatarUrl,
  assigneeType,
}: UseDisplayAssigneeParams): DisplayAssignee | null {
  const [displayAssignee, setDisplayAssignee] = useState<DisplayAssignee | null>(
    assigneeId
      ? {
          name: assigneeName ?? null,
          avatarUrl: assigneeAvatarUrl ?? null,
          type: assigneeType,
        }
      : null
  );

  useEffect(() => {
    if (open) {
      setDisplayAssignee(
        assigneeId
          ? {
              name: assigneeName ?? null,
              avatarUrl: assigneeAvatarUrl ?? null,
              type: assigneeType,
            }
          : null
      );
    }
  }, [open, assigneeId, assigneeName, assigneeAvatarUrl, assigneeType]);

  return displayAssignee;
}
